import { request } from '@/store/client'
import { LoginDomain } from '@/types'

export const getLoginDomain = (domain: string): Promise<LoginDomain> => {
  const encodedDomain = encodeURIComponent(domain)

  return request({
    url: `/login-domains/${encodedDomain}`,
    method: 'get',
  }).then((response) => {
    return response.data as LoginDomain
  })
}
